import moment from 'moment';

export const FEEDBACKS_FILTERS_KEY = 'relatorios.kpis';

// Defaults depend on "today", so they are built at mount (usePersistedFilters),
// never once at module load. Dates are kept as 'YYYY-MM-DD' strings.
export const getDefaultFeedbacksFilters = () => ({
  from: moment().startOf('month').format('YYYY-MM-DD'),
  to: moment().endOf('month').format('YYYY-MM-DD'),
});

// Turns the saved period into the /feedbacks params.
export const getFeedbacksRequest = (filters) => ({
  initialDate: filters.from,
  finalDate: filters.to,
});

export const isFeedbacksPeriodDefault = (filters, defaults) =>
  filters.from === defaults.from && filters.to === defaults.to;

// RangePicker value: fresh moments built from the strings on every render.
export const getFeedbacksRange = (filters) => [
  moment(filters.from, 'YYYY-MM-DD'),
  moment(filters.to, 'YYYY-MM-DD'),
];

// RangePicker change -> saved period. Returns null when the range is incomplete.
export const getFeedbacksPeriodFromRange = (dates) => {
  if (!dates || !dates[0] || !dates[1]) return null;
  return {
    from: dates[0].format('YYYY-MM-DD'),
    to: dates[1].format('YYYY-MM-DD'),
  };
};

// Pill label with the year, so a period from another year is not ambiguous.
export const getFeedbacksPeriodLabel = (filters) =>
  moment(filters.from, 'YYYY-MM-DD').format('DD/MM/YYYY') + ' - ' + moment(filters.to, 'YYYY-MM-DD').format('DD/MM/YYYY');

// Badge: only what differs from the defaults.
export const countActiveFeedbacksFilters = (filters, defaults) =>
  isFeedbacksPeriodDefault(filters, defaults) ? 0 : 1;
